import { Helmet } from "react-helmet";
import hero from "../images/kamaainaHero.jpg";
import leftWaikiki from "../images/kamaainaWaikiki.jpg";
import leftMajestic from "../images/kamaainaSunset.jpg";
import leftFireworks from "../images/kamaainaFireworks.jpg";
import LeftRight from "../components/LeftRight";

function Industry() {
  return (
    <>
      <Helmet>
        <title>Atlantis Submarine Adventures | Industry Discounts</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
      </Helmet>
      <div className="container mw-100">
        <div className="row position-relative heightVideo">
          <img src={hero} className="p-0 homeVidSizeNew" alt="hero" />
          <div className="homeTextOverlayVideo fw-semibold lh-sm">
            INDUSTRY DISCOUNTS
          </div>
        </div>
        <div
          className="row bg-light text-start justify-content-center"
          style={{ color: "#03286B" }}
        >
          <div className="col-12 col-md-10 col-xl-9 col-xxl-6 py-5">
            <p className="fs-2 fw-bold mb-4 text-center">
              Mahalo to Our Industry Partners!
            </p>
            <p className="mb-4">
              Join us with complimentary tickets! Atlantis Adventures would like
              to host you and one guest aboard one of our Oahu tours. Explore
              Waikiki both above and beneath the sea!
            </p>
            <p className="mb-4" style={{ fontSize: ".8rem" }}>
              This special offer can only be used one time on an Oahu tour. It's
              good for the month of April and May 2026. For Atlantis Submarines
              Waikiki, complimentary seats are valid on the 1pm submarine dive
              only.
            </p>
            <p className="mb-0" style={{ fontSize: ".8rem" }}>
              *For industry professionals. Please bring proof of employment when
              checking in. This promotion can be cancelled anytime. Call
              808.973.9811 for questions.
            </p>
          </div>
        </div>
        <LeftRight
          left={leftWaikiki}
          title="ATLANTIS SUBMARINES WAIKIKI"
          p1="Explore a side of Waikiki over 100 feet beneath the sea that you and your Ohana may have never seen before in an air-conditioned submarine. Add deeper meaning to your next adventure by discovering marine life, sunken ships and other fascinating artificial reefs in the world’s largest battery-powered, Coast Guard-approved sub."
          p2={
            <>
              Transportation not included.
              <br />
              *A valid Industry card or paystub is required at check-in*
            </>
          }
          link="https://atlantisadventures.rezgo.com/details/151625/atlantis-submarine-tour-in-waikiki/?promo=mahalo26"
          button
          kamaaina
          adult="0"
          child="0"
          saveAdult="148"
          saveChild="66"
          thingsReal
        />
        <LeftRight
          left={leftMajestic}
          title="MAJESTIC WAIKIKI SUNSET COCKTAIL CRUISE"
          p1="Step out onto Majestic’s open-air decks and enjoy Hawaii’s beautiful sunsets and skylines. Majestic features two decks that offer the space to take in panoramic views and lovely breezes."
          p2={
            <>
              Tax and harbor fee added at checkout. Transportation not included.
              <br />
              *A valid Industry card or paystub is required at check-in*
            </>
          }
          link="https://atlantisadventures.rezgo.com/details/204130/waikiki-sunset-cocktail-cruise/?promo=mahalo26"
          changeBG
          button
          kamaaina
          adult="0"
          child="0"
          saveAdult="79"
          saveChild="39.50"
          thingsReal
        />
        <LeftRight
          left={leftFireworks}
          title="MAJESTIC FRIDAY FIREWORKS & COCKTAIL CRUISE"
          p1="Experience an unforgettable evening with Friday night fireworks and cocktails on the sea aboard Majestic by Atlantis Cruises."
          p2={
            <>
              Tax and harbor fee added at checkout. Transportation not included.
              <br />
              *A valid Industry card or paystub is required at check-in*
            </>
          }
          link="https://atlantisadventures.rezgo.com/details/205347/friday-fireworks-cocktail-cruise/?promo=mahalo26"
          button
          kamaaina
          adult="0"
          child="0"
          saveAdult="79"
          saveChild="39.50"
          thingsReal
        />
      </div>
    </>
  );
}

export default Industry;
